import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { EtcProvider } from "./context/EtcContext";
import GlobalStyle from "./GlobalStyles";
import { BrowserRouter as Router } from "react-router-dom";
import "./i18n";
import { createBrowserHistory } from "history";
import { HelmetProvider } from "react-helmet-async";

export const history = createBrowserHistory({
  basename: "https://playgroundetc.ca/",
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    <EtcProvider>
      <GlobalStyle />
      <HelmetProvider>
        <Router history={history}>
          <App />
        </Router>
      </HelmetProvider>
    </EtcProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
